import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { Headline } from '@ldfeplatform/componentlibrary.ui.molecules.headline';
import { HorizontalFeatureCard } from '@ldfeplatform/componentlibrary.ui.molecules.feature-card';

import { BB_SERVICES } from '@/data/constants';
import { IBBServices } from './beauty-boutique-services.interface';
import { IHeaderGroupProps } from '../search-results-content/search-results-content.interface';
import styles from './beauty-boutique-services.module.scss';

const BeautyBoutiqueServices: FC<IBBServices> = ({ bbServices = [] }) => {
  const { formatMessage } = useIntl();

  if (!bbServices?.length) return null;

  const headerGroupProps: IHeaderGroupProps = {
    title: formatMessage({ id: 'bbServiceHeader' }),
    subTitle: formatMessage({ id: 'bbServiceSubtitle' }),
    headlineSize: 3,
    paragraphSize: 2,
  };

  const bbServiceCards = () =>
    bbServices?.map((service) => {
      const serviceDetails = BB_SERVICES[service.name] || {};
      const { title, description, image } = serviceDetails;

      return (
        <div className={styles.bbServiceCard} key={service.name} data-testid="horizontal-feature-card">
          <HorizontalFeatureCard
            variant="horizontal"
            title={formatMessage({ id: title })}
            cardImage={image}
            cardContent={formatMessage({ id: description })}
            altText={`bbService-${title}`}
          />
        </div>
      );
    });

  return (
    <div className={styles.bbServiceContainer}>
      <Headline {...headerGroupProps} />
      {bbServiceCards()}
    </div>
  );
};

export default BeautyBoutiqueServices;
